<template>
    <div class="app-container">
      <div class="title-row"><span class="title">{{ this.$route.meta.title }}</span></div>
      <el-form :model="queryParams" ref="pl5Form" size="small" :inline="true" v-show="showSearch" label-width="68px">
        <el-form-item label="起始期数">
          <el-input v-model="queryParams.startPeriod" placeholder="开始期数" clearable style="width: 100px;"/>
          -
          <el-input v-model="queryParams.endPeriod" placeholder="结束期数" clearable style="width: 100px;"/>
        </el-form-item>
        <el-form-item label="数字1" prop="num1">
          <el-input v-model="queryParams.num1" placeholder="数字1" clearable style="width: 80px;"/>
        </el-form-item>
        <el-form-item label="数字2" prop="num2">
          <el-input v-model="queryParams.num2" placeholder="数字2" clearable style="width: 80px;"/>
        </el-form-item>
        <el-form-item label="数字3" prop="num3">
          <el-input v-model="queryParams.num3" placeholder="数字3" clearable style="width: 80px;"/>
        </el-form-item>
        <el-form-item label="数字4" prop="num4">
          <el-input v-model="queryParams.num4" placeholder="数字4" clearable style="width: 80px;"/>
        </el-form-item>
        <el-form-item label="数字5" prop="num5">
          <el-input v-model="queryParams.num5" placeholder="数字5" clearable style="width: 80px;"/>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" size="mini" @click="handleQueryPl5">搜索</el-button>
          <el-button icon="el-icon-refresh" size="mini" @click="resetQueryPl5">重置</el-button>
        </el-form-item>
      </el-form>
      <el-row :gutter="10" class="mb8">
        <el-col :span="1.5">
          <el-button v-hasPermi="['lottery:pl5:init']" type="primary" plain icon="el-icon-refresh-right" size="mini" @click="handleInitAllPl5">
            全部初始化
          </el-button>
        </el-col>
        <el-col :span="1.5">
          <el-button v-hasPermi="['lottery:pl5:fill']" type="primary" plain icon="el-icon-refresh-right" size="mini" @click="handleFillPl5History">
            补全历史数据
          </el-button>
        </el-col>
        <el-col :span="1.5">
          <el-button v-hasPermi="['lottery:pl5:export']" type="warning" plain icon="el-icon-export" size="small" @click="handleExportPl5">导出</el-button>
        </el-col>
        <el-col :span="1.5">
          <el-button v-hasPermi="['lottery:pl5:initC']" type="success" plain icon="el-icon-refresh-left" size="small" @click="handleInitAllPl5C">
            初始化统计数据
          </el-button>
        </el-col>
        <el-col :span="1.5">
          <el-button v-hasPermi="['lottery:pl5:exportC']" type="warning" plain icon="el-icon-export" size="small" @click="handleOpenC()">导出统计数据
          </el-button>
        </el-col>
        <el-col :span="1.5">
          <el-button v-hasPermi="['lottery:pl5:cache']" type="danger" plain icon="el-icon-export" size="small" @click="handleRefreshPl5">刷新缓存
          </el-button>
        </el-col>
        <el-col :span="1.5">
          <el-button v-hasPermi="['lottery:pl5:gen']" type="success" plain icon="el-icon-refresh-left" size="small" @click="handleOpenGeneratePl5">
            生成排列五
          </el-button>
        </el-col>
        <el-col :span="1.5">
          <el-button v-hasPermi="['lottery:pl5:exportF']" type="warning" plain icon="el-icon-export" size="small" @click="exportFrequency">导出组合频率
          </el-button>
        </el-col>
        <right-toolbar :show-search.sync="showSearch" @queryTable="getPl5List" />
      </el-row>
      <el-table :data="pl5List" v-loading="loading" border highlight-current-row
                :cell-class-name="cellClassName">
        <el-table-column label="期号" align="center" prop="period"/>
        <el-table-column label="数字号码" align="center">
          <el-table-column label="1" align="center" prop="num1"/>
          <el-table-column label="2" align="center" prop="num2"/>
          <el-table-column label="3" align="center" prop="num3"/>
          <el-table-column label="4" align="center" prop="num4"/>
          <el-table-column label="5" align="center" prop="num5"/>
        </el-table-column>
        <el-table-column label="奖池金额" align="right" prop="pondAmount" min-width="100px">
          <template slot-scope="scope">
            {{ formatYuan(scope.row.pondAmount) }}
          </template>
        </el-table-column>
        <el-table-column label="一等奖" align="center">
          <el-table-column label="注数" align="center" prop="firstCount"/>
          <el-table-column label="奖金(元)" align="right" prop="firstAmount" min-width="90px">
            <template slot-scope="scope">
              {{ formatYuan(scope.row.firstAmount) }}
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column label="销售金额" align="right" prop="saleAmount" min-width="100px">
          <template slot-scope="scope">
            {{ formatYuan(scope.row.saleAmount) }}
          </template>
        </el-table-column>
        <el-table-column label="开奖日期" align="center" prop="lotteryDate" min-width="90px">
          <template slot-scope="scope">
            {{ scope.row.lotteryDate | date }}
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="210px">
          <template slot-scope="scope">
            <el-button v-hasPermi="['lottery:pl5:win']" type="text" icon="el-icon-data-analysis" @click="handleWinning(scope.row)">概率</el-button>
            <el-button v-hasPermi="['lottery:pl5:next']" type="text" icon="el-icon-medal" @click="handleNextHistory(scope.row.period)">下期</el-button>
            <el-button v-hasPermi="['lottery:pl5:nextF']" type="text" icon="el-icon-medal" @click="handleNextNum(scope.row.period)">频率</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination
        v-show="total>0"
        :total="total"
        :page.sync="queryParams.current"
        :limit.sync="queryParams.size"
        @pagination="getPl5List"
        :page-sizes="[10, 20, 30, 50, 100, 200]"
      />
      <!-- 导出统计次数弹出层 -->
      <el-dialog :title="cTitle" :visible.sync="cOpen" width="300px" :close-on-click-modal="false">
        <el-form ref="cForm" :model="cForm" :rules="cRules" label-width="110px" label-suffix="：">
          <el-form-item prop="isC">
                    <span slot="label">
                      是否排序
                      <el-popover
                        placement="top-start"
                        width="250"
                        trigger="hover"
                        content="如果排序为是，导出数据号码为历史出现次数从多到少的顺序;否则按照数据号码从小到大排序">
                        <i slot="reference" class="el-icon-question"></i>
                      </el-popover>
                    </span>
            <el-select v-model="cForm.isC" placeholder="请选择是否" style="width: 140px">
              <el-option :key="true" label="是" :value="true"></el-option>
              <el-option :key="false" label="否" :value="false"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="exportC">导出</el-button>
          <el-button @click="cancelC">取消</el-button>
        </div>
      </el-dialog>
      <!-- 生成排列五弹出层 -->
      <el-dialog title="生成排列五" :visible.sync="generatePl5Open" width="750px" :close-on-click-modal="false">
        <el-form ref="generatePl5Form" :model="generatePl5Form" :inline="true" :rules="generatePl5Rules"
                 label-width="80px">
          <el-form-item label="生成个数" prop="count">
            <el-select v-model="generatePl5Form.count" placeholder="请选择个数">
              <el-option :key="1" label="1" :value="1"/>
              <el-option :key="5" label="5" :value="5"/>
              <el-option :key="10" label="10" :value="10"/>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" size="mini" @click="handleGeneratePl5">生成</el-button>
            <el-button icon="el-icon-refresh" size="mini" @click="resetGeneratePl5">重置</el-button>
          </el-form-item>
        </el-form>
        <el-table :data="generatePl5List" border style="width: 100%" :cell-class-name="cellClassName"
                  highlight-current-row>
          <el-table-column label="数字号码" align="center">
            <el-table-column label="1" align="center" prop="num1"/>
            <el-table-column label="2" align="center" prop="num2"/>
            <el-table-column label="3" align="center" prop="num3"/>
            <el-table-column label="4" align="center" prop="num4"/>
            <el-table-column label="5" align="center" prop="num5"/>
          </el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <el-button v-hasPermi="['lottery:pl5:win']" type="text" icon="el-icon-data-analysis" @click="handleWinning(scope.row)">概率</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="close">关闭</el-button>
        </div>
      </el-dialog>
      <!-- 往期中奖概率弹出层 -->
      <el-dialog title="往期中奖概率" :visible.sync="winningOpen" width="500px">
        <el-row :gutter="20" v-for="(item,index) in winningList" :key="index" style="padding: 5px 0">
          <el-col :span="8">{{ item.name }}</el-col>
          <el-col :span="8">注数：{{ item.count }}</el-col>
          <el-col :span="8">概率：{{ formatMoney(item.winningRate * 100, 2) }}%</el-col>
        </el-row>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="winningOpen=false">关 闭</el-button>
        </div>
      </el-dialog>
      <!-- 下期排列五同期历史数据弹出层 -->
      <el-dialog :title="pl5HistoryTitle" :visible.sync="pl5HistoryOpen" width="600px" :close-on-click-modal="false">
        <el-tabs v-model="activePl5HistoryName" type="border-card">
          <el-tab-pane label="历史同期数据" name="firstPl5">
            <el-table :data="pl5HistoryList" border style="width: 100%" :cell-class-name="cellClassName"
                      highlight-current-row>
              <el-table-column label="期数" align="center" prop="period" width="70"/>
              <el-table-column label="数字号码" align="center">
                <el-table-column label="1" align="center" prop="num1" width="60"/>
                <el-table-column label="2" align="center" prop="num2" width="60"/>
                <el-table-column label="3" align="center" prop="num3" width="60"/>
                <el-table-column label="4" align="center" prop="num4" width="60"/>
                <el-table-column label="5" align="center" prop="num5" width="60"/>
              </el-table-column>
              <el-table-column label="总和" align="center" prop="totalSum" width="70"/>
              <el-table-column label="跨度" align="center" prop="numSpan"/>
            </el-table>
          </el-tab-pane>
          <el-tab-pane label="统计数据" name="secondPl5">
            <el-row :gutter="10">
              <el-col :span="6" style="text-align: right">数字1次数排名：</el-col>
              <el-col :span="18">
                <el-row :gutter="10">
                  <el-col v-for="(item,index) in pl5HistoryRedOneList" :key="item.num" :span="6"><span
                    style="font-weight: bold">{{ index + 1 }}.</span> <span style="color: #d73a49">{{ item.num }}</span>
                    ({{ item.counts }}次)
                  </el-col>
                </el-row>
              </el-col>
            </el-row>
            <el-row :gutter="10">
              <el-col :span="6" style="text-align: right">数字2次数排名：</el-col>
              <el-col :span="18">
                <el-row :gutter="10">
                  <el-col v-for="(item,index) in pl5HistoryRedTwoList" :key="item.num" :span="6"><span
                    style="font-weight: bold">{{ index + 1 }}.</span> <span style="color: #d73a49">{{ item.num }}</span>
                    ({{ item.counts }}次)
                  </el-col>
                </el-row>
              </el-col>
            </el-row>
            <el-row :gutter="10">
              <el-col :span="6" style="text-align: right">数字3次数排名：</el-col>
              <el-col :span="18">
                <el-row :gutter="10">
                  <el-col v-for="(item,index) in pl5HistoryRedThreeList" :key="item.num" :span="6"><span
                    style="font-weight: bold">{{ index + 1 }}.</span> <span style="color: #d73a49">{{ item.num }}</span>
                    ({{ item.counts }}次)
                  </el-col>
                </el-row>
              </el-col>
            </el-row>
            <el-row :gutter="10">
              <el-col :span="6" style="text-align: right">数字4次数排名：</el-col>
              <el-col :span="18">
                <el-row :gutter="10">
                  <el-col v-for="(item,index) in pl5HistoryRedFourList" :key="item.num" :span="6"><span
                    style="font-weight: bold">{{ index + 1 }}.</span> <span style="color: #d73a49">{{ item.num }}</span>
                    ({{ item.counts }}次)
                  </el-col>
                </el-row>
              </el-col>
            </el-row>
            <el-row :gutter="10">
              <el-col :span="6" style="text-align: right">数字5次数排名：</el-col>
              <el-col :span="18">
                <el-row :gutter="10">
                  <el-col v-for="(item,index) in pl5HistoryRedFiveList" :key="item.num" :span="6"><span
                    style="font-weight: bold">{{ index + 1 }}.</span> <span style="color: #d73a49">{{ item.num }}</span>
                    ({{ item.counts }}次)
                  </el-col>
                </el-row>
              </el-col>
            </el-row>
          </el-tab-pane>
        </el-tabs>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="pl5HistoryOpen=false">关闭</el-button>
        </div>
      </el-dialog>

      <!-- 下期排列五数字频率弹出层 -->
      <el-dialog :title="pl5NumTitle" :visible.sync="pl5NumOpen" width="1200px" :close-on-click-modal="false">
        <el-row :gutter="10">
          <el-col :span="2" style="text-align: right">全部数字：</el-col>
          <el-col :span="22">
            <el-row v-for="item in allList" :key="item.num" :gutter="10">
              <el-col :span="1" style="color: #d73a49;font-weight: bold">{{ item.num }}：</el-col>
              <el-col :span="23">
                <el-row :gutter="10" style="margin-bottom: 10px">
                  <el-col v-for="(subItem,index) in item.numDataList" :key="subItem.num" :span="3"><span
                    style="font-weight: bold">{{ index + 1 }}.</span> <span
                    style="color: #d73a49">{{ subItem.num }}</span> ({{ subItem.counts }}次)
                  </el-col>
                </el-row>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
        <el-divider/>
        <el-row :gutter="10">
          <el-col :span="2" style="text-align: right">同位数字：</el-col>
          <el-col :span="22">
            <el-row v-for="item in digitList" :key="item.num" :gutter="10">
              <el-col :span="1" style="color: #d73a49;font-weight: bold">{{ item.num }}：</el-col>
              <el-col :span="23">
                <el-row :gutter="10" style="margin-bottom: 10px">
                  <el-col v-for="(subItem,index) in item.numDataList" :key="subItem.num" :span="3"><span
                    style="font-weight: bold">{{ index + 1 }}.</span> <span
                    style="color: #d73a49">{{ subItem.num }}</span> ({{ subItem.counts }}次)
                  </el-col>
                </el-row>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="pl5NumOpen=false">关闭</el-button>
        </div>
      </el-dialog>
    </div>
</template>
<script>
import {listPl5, initAllPl5, fillHistoryData, initAllPl5C, refreshPl5Cache, generatePl5, getPl5WinningData, getNextPl5History, getNextNumFrequency } from '@/api/lottery/pl5'

export default {
  data() {
    return {
      // 遮罩层
      loading: '',
      showSearch:true,
      //排列五数据
      pl5List: [],
      // 排列五数量
      total: 0,
      // 查询参数
      queryParams: {
        current: 1,
        size: 10,
        startPeriod: null,
        endPeriod: null,
        num1: null,
        num2: null,
        num3: null,
        num4: null,
        num5: null,
      },
      cTitle: '',
      cOpen: false,
      cForm: {},
      cRules: {
        isC: [
          {required: true, message: '是否不能为空', trigger: 'blur'}
        ]
      },
      generatePl5Open: false,
      generatePl5Form: {
        count: 1
      },
      generatePl5Rules: {
        count: [
          {required: true, message: '个数不能为空', trigger: 'blur'}
        ]
      },
      generatePl5List: [],
      winningList: [],
      winningOpen: false,

      activePl5HistoryName: 'firstPl5',
      pl5HistoryOpen: false,
      pl5HistoryTitle: '',
      pl5HistoryList: [],
      pl5HistoryRedOneList: [],
      pl5HistoryRedTwoList: [],
      pl5HistoryRedThreeList: [],
      pl5HistoryRedFourList: [],
      pl5HistoryRedFiveList: [],

      pl5NumTitle: '',
      pl5NumOpen: false,
      allList: [],
      digitList: []
    }
  },
  created() {
    this.getPl5List()
  },
  methods: {
    cellClassName({row, column, rowIndex, columnIndex}) {
      if (column.property) {
        if (column.property === 'num1' || column.property === 'num2' || column.property === 'num3' || column.property === 'num4' || column.property === 'num5') {
          return 'red-ball';
        }
      }
    },
    /** 查询排列五列表 */
    getPl5List() {
      listPl5(this.queryParams).then(res => {
        this.pl5List = res.rows;
        this.total = res.total
      })
    },
    /** 搜索排列五列表 **/
    handleQueryPl5() {
      this.queryParams.current = 1;
      this.getPl5List()
    },
    /** 重置排列五按钮操作 */
    resetQueryPl5() {
      this.queryParams.startPeriod = undefined;
      this.queryParams.endPeriod = undefined;

      this.resetForm("pl5Form");
      this.handleQueryPl5();
    },
    /** 初始化排列五数据 **/
    handleInitAllPl5() {
      this.$modal.confirm("确定要初始化全部排列五数据吗？确认后将全部重新生成！").then(action => {
        if (action === 'confirm') {
          this.$modal.loading("正在初始化中，请稍后...")
          initAllPl5().then(res => {
            this.$modal.closeLoading()
            this.$modal.msgSuccess("初始化成功")
            this.handleQueryPl5();
          }).catch(()=>{
            this.$modal.closeLoading()
          })
        }
      }).catch(()=> {})
    },
    /** 补全排列五历史数据 **/
    handleFillPl5History() {
      this.$modal.confirm("确定要补全排列五历史数据吗？").then(action => {
        if (action === 'confirm') {
          this.$modal.loading("正在补全中，请稍后...")
          fillHistoryData().then(res => {
            this.$modal.closeLoading()
            this.$modal.msgSuccess("补全成功")
            this.handleQueryPl5();
          }).catch(()=>{
            this.$modal.closeLoading()
          })
        }
      }).catch(()=> {})
    },

    /** 导出大排列五按钮操作 */
    handleExportPl5() {
      this.download('/admin/lottery/pl5/export', {
        ...this.queryParams
      }, `排列五导出_${new Date().getTime()}.xlsx`)
    },

    /** 初始化排列五统计数据 **/
    handleInitAllPl5C() {
      this.$modal.confirm("确定要初始化排列五统计数据吗？").then(action => {
        if(action === 'confirm'){
          this.$modal.loading("正在初始化中，请稍后...")
          initAllPl5C().then(res => {
            this.$modal.closeLoading()
            this.$modal.msgSuccess("初始化成功")
            this.handleQueryPl5();
          }).catch(()=>{
            this.$modal.closeLoading()
          })
        }
      }).catch(()=>{ })
    },
    /** 刷新排列五缓存 **/
    handleRefreshPl5() {
      refreshPl5Cache().then(() => {
        this.$modal.msgSuccess("刷新成功");
      })
    },
    /** 打开生成排列五弹窗 */
    handleOpenGeneratePl5() {
      this.generatePl5Open = true;
      this.$set(this.generatePl5Form, 'count', 1)
      this.resetForm("generatePl5Form");
      this.generatePl5List = []
    },
    handleGeneratePl5() {
      this.$refs["generatePl5Form"].validate(valid => {
        if (valid) {
          generatePl5(this.generatePl5Form).then(res => {
            if (res.flag) {
              this.generatePl5List = res.data
            }
          })
        }
      })
    },
    resetGeneratePl5() {
      this.generatePl5List = []
      this.$set(this.generatePl5Form, 'count', 1)
      this.resetForm("generatePl5Form");
    },
    /** 获奖概率弹窗 **/
    handleWinning(row) {
      this.winningList = [];
      let queryParams = {
        num1: row.num1,
        num2: row.num2,
        num3: row.num3,
        num4: row.num4,
        num5: row.num5,
        period: row.period
      }
      getPl5WinningData(queryParams).then(res => {
        this.winningList = res.data
        this.winningOpen = true;
      })
    },
    /** 下期历史同期数据 **/
    handleNextHistory(period) {
      this.pl5HistoryList = [];
      this.pl5HistoryRedOneList = [];
      this.pl5HistoryRedTwoList = [];
      this.pl5HistoryRedThreeList = [];
      this.pl5HistoryRedFourList = [];
      this.pl5HistoryRedFiveList = [];
      getNextPl5History(period).then(res => {
        this.pl5HistoryList = res.data.lotteryDataList;
        this.pl5HistoryRedOneList = res.data.num1Data;
        this.pl5HistoryRedTwoList = res.data.num2Data;
        this.pl5HistoryRedThreeList = res.data.num3Data;
        this.pl5HistoryRedFourList = res.data.num4Data;
        this.pl5HistoryRedFiveList = res.data.num5Data;
        this.pl5HistoryTitle = "【" + res.data.period + "】期排列五历史同期统计";
        this.pl5HistoryOpen = true;
      })
    },
    /** 打开导出彩票统计次数弹窗 **/
    handleOpenC() {
      this.cOpen = true;
      this.cTitle = "排列五统计数据导出";
    },
    /** 导出统计次数 **/
    exportC() {
      this.$refs["cForm"].validate(valid => {
        if (valid) {
          this.download('/admin/lottery/pl5/exportC', {
            ...this.cForm
          }, `排列五统计数据导出_${new Date().getTime()}.xlsx`)
        }
      });
    },
    cancelC() {
      this.cOpen = false;
      this.cForm = {};
      this.resetForm("cForm");
    },
    close() {
      this.generatePl5Open = false;
    },
    exportFrequency() {
      this.download('/admin/lottery/pl5/exportFrequency', {
        ...this.queryParams
      }, `排列五数字组合频率导出_${new Date().getTime()}.xlsx`)
    },
    handleNextNum(period) {
      this.allList = [];
      this.digitList = [];
      this.pl5NumTitle = "【" + period + "】期排列五下期数字频率";
      let params = {period: period, count: null}
      getNextNumFrequency(params).then(res => {
        this.allList = res.allList;
        this.digitList = res.digitList;
        this.pl5NumOpen = true;
      })
    }
  }
}
</script>

